import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import config from '../runtime-config';
import { serviceTarget, requestServiceAccess } from '../services/serviceAccess';

export default function ServiceAccess() {
  const { getIdToken } = useAuth();
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setError('');
    (async () => {
      try {
        const target = serviceTarget(window.location.search);
        const token = await getIdToken();
        if (controller.signal.aborted) return;
        const url = await requestServiceAccess({ config, token, target, signal: controller.signal });
        if (!controller.signal.aborted) window.location.replace(url);
      } catch (cause) {
        if (!controller.signal.aborted) setError(cause.message || 'Could not open this service.');
      }
    })();
    return () => controller.abort();
  }, [getIdToken, attempt]);
  return <main className="center-wrapper">
    <section aria-label="Device service access" style={{ maxWidth: 480, padding: 24 }}>
      <h1>Device service access</h1>
      {error ? <><p role="alert">{error}</p><button onClick={() => setAttempt(value => value + 1)}>Try again</button></> : <p>Checking your access and the device connection…</p>}
      <p><a href="/dashboard">Return to Davax</a></p>
    </section>
  </main>;
}
